import { atom } from 'recoil';

const currentChildAtom = atom({
    key: 'childId',
    default: {}
});

export {
    currentChildAtom
};